import { indexItems } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            按题材分类浏览，快速找到你喜欢的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href={`#cards`}
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#cards');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-1">
                  {item.desc}
                </p>
                <span className="inline-block mt-2 text-[11px] text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full">
                  {item.count} 部作品
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}